export function updateSitesState(state, payload) {
  state[payload.state] = payload.data;
}
